import 'bootstrap-daterangepicker/daterangepicker.css';
import { orderBy } from 'lodash';
import { endOfDay, format, startOfDay } from 'date-fns';
import moment from 'moment';
import Pagination from 'rc-pagination';
import React, { Component } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Button, Col, Container, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import * as CompanyActions from '../actions/Companies';
import { getCompanyNumbers } from '../actions/Numbers';
import { cancelDeleteUser, showDeleteUser } from '../actions/Users';
import * as VmailActions from '../actions/Vmails';
import Breadcrumbs from '../components/Breadcrumb';
import CompanyAutocomplete from '../components/CompanyAutocomplete';
import DeleteModal from '../components/DeleteModal';
import SetLimitEntries from '../components/SetLimitEntries';
import UsersAutocomplete from '../components/UserAutocomplete';
import VmailsList from '../components/VmailsList';
import WithUserData from '../HOC/withUserData';
import Calendar from '../Res/Icon/Calendar.png';
import filterIcon from '../Res/Icon/filter.png';
import './vmail.css';
import { ENG_LOCALE } from '../lib/constants';
class Vmails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFilter: 'Company',
      // date: [startOfDay(new Date()), endOfDay(new Date())],
      date: [endOfDay(new Date()), moment().subtract(6, 'days')._d],
      selectedUser: '',
      selectedCompany: '',
      sort: {
        name: '',
        order: '',
      },
    };
    this.token = localStorage.getItem('jwtToken') || null;
    this.pageLimit = 10;
    this.pageNumber = 1;
    this.ranges = {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'Last 30 Days': [moment().subtract(29, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment()
          .subtract(1, 'month')
          .startOf('month'),
        moment()
          .subtract(1, 'month')
          .endOf('month'),
      ],
    };
  }

  componentWillMount() {
    this.props.getAllVmails(localStorage.getItem('jwtToken'));
    if (this.props.user.role === 'admin' || this.props.user.role === 'enterpriseAdmin') {
      this.props.getCompanyNumbers(this.token, this.props.user.company._id, true, 'none');
    }
  }

  handleChangePagination = async numPage => {
    const { selectedCompany, selectedUser } = this.state;
    const { vmail, getAllVmails, getVmailByCompany, getVmailsByUser } = this.props;
    this.pageNumber = numPage;
    if (selectedCompany === '' && selectedUser === '') {
      await getAllVmails(this.token, { page: numPage, limit: vmail.limit }, this.state.date);
    } else {
      if (selectedUser !== '') {
        await getVmailsByUser(
          this.token,
          selectedUser,
          {
            page: numPage,
            limit: vmail.limit,
          },
          this.state.date,
        );
      } else if (selectedCompany !== '') {
        await getVmailByCompany(
          this.token,
          selectedCompany,
          {
            page: numPage,
            limit: vmail.limit,
          },
          this.state.date,
        );
      }
    }
  };

  handleSetLimit = async limit => {
    const { selectedCompany, selectedUser } = this.state;
    const { getAllVmails, getVmailByCompany, getVmailsByUser } = this.props;

    this.pageLimit = limit;
    if (selectedCompany === '' && selectedUser === '') {
      await getAllVmails(this.token, { page: this.pageNumber, limit: +limit }, this.state.date);
    } else {
      if (selectedUser !== '') {
        await getVmailsByUser(
          this.token,
          selectedUser,
          {
            page: this.pageNumber,
            limit: +limit,
          },
          this.state.date,
        );
      } else if (selectedCompany !== '') {
        await getVmailByCompany(
          this.token,
          selectedCompany,
          {
            page: this.pageNumber,
            limit: +limit,
          },
          this.state.date,
        );
      }
    }
  };

  handeleClick = e => {
    const el = document.querySelector('.daterangepicker');
    el.classList.toggle('show-dp');
  };

  onApply = (e, piker) => {
    const { getAllVmails, getVmailsByUser, getVmailByCompany } = this.props;
    const { selectedUser, selectedCompany } = this.state;
    const dataEnd = piker.endDate._d;
    const dataStart = piker.startDate._d;

    this.setState({ date: [dataEnd, dataStart] }, () => {
      if (selectedUser === '' && selectedCompany === '') {
        getAllVmails(this.token, {}, this.state.date);
      } else if (selectedUser !== '') {
        getVmailsByUser(
          this.token,
          selectedUser,
          { page: this.pageNumber, limit: this.pageLimit },
          this.state.date,
        );
      } else if (selectedCompany !== '') {
        getVmailByCompany(
          this.token,
          selectedCompany,
          { page: this.pageNumber, limit: this.pageLimit },
          this.state.date,
        );
      }
    });
  };

  companySearchFilter = async ({ name, value, suggestion }) => {
    const { getAllVmails, getVmailByCompany, getCompanyNumbers } = this.props;
    if (suggestion !== null) {
      this.setState({ selectedCompany: suggestion._id });
      await getCompanyNumbers(this.token, suggestion._id, true, 'none');
      await getVmailByCompany(
        this.token,
        suggestion._id,
        { page: this.pageNumber, limit: this.pageLimit },
        this.state.date,
      );
    } else {
      this.setState({ selectedCompany: '' });
      getAllVmails(
        localStorage.getItem('jwtToken'),
        { page: this.pageNumber, limit: this.pageLimit },
        this.state.date,
      );
    }
  };

  onUserTypeSelect = async ({ suggestion }) => {
    const { getVmailsByUser, getVmailByCompany } = this.props;
    if (suggestion !== null) {
      this.setState({ selectedUser: suggestion._id });
      getVmailsByUser(
        this.token,
        suggestion._id,
        { page: this.pageNumber, limit: this.pageLimit },
        this.state.date,
      );
    } else {
      this.setState({ selectedUser: '' });
      await getVmailByCompany(
        this.token,
        this.state.selectedCompany,
        { page: this.pageNumber, limit: this.pageLimit },
        this.state.date,
      );
      // getAllVmails(localStorage.getItem('jwtToken'), { page: this.pageNumber, limit: this.pageLimit }, this.state.date);
    }
  };

  onOptionSelect = e => {
    this.setState({ selectedFilter: e });
  };

  onDelete = async e => {
    const res = await this.props.deleteVMail(this.token, this.state.deleteVmail);
    if (res) {
      this.handleChangePagination(this.pageNumber);
    }
  };

  onRecoverVmail = async e => {
    var res = await this.props.onRecover(this.token, e);
    if (res) {
      this.handleChangePagination(this.pageNumber);
    }
  };

  handleSortVmail = filter => {
    const { sort } = this.state;
    const updateSort = { ...sort };

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    this.setState({ sort: updateSort });
  };

  sortColumnByKey = array => {
    const { sort } = this.state;

    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(array, [el => el[sortNameArr[0]][sortNameArr[1]].toLowerCase()], [sort.order]);
    } else if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name].toLowerCase()], [sort.order]);
    } else {
      return orderBy(array, [el => el[sort.name]], [sort.order]);
    }
  };

  render() {
    const { date, sort } = this.state;
    const { user, vmail, emails, deleteMode } = this.props;
    if (!user || !user._id) {
      return <Redirect to="/login" />;
    }

    const renderList = sort.name.length
      ? vmail?.docs?.length && this.sortColumnByKey(vmail.docs)
      : vmail.docs;
    return (
      <div>
        <div className="filter-section">
          <Row>
            {/* <Col md={3} sm={12}>
              <Breadcrumbs />
            </Col> */}
            <Col md={12} sm={12}>
              <Row className="justify-content-end">
                {/* <Col md="3" className="select-limit">
                  <SetLimitEntries value={vmail.limit} onChange={this.handleSetLimit} />
                </Col> */}

                {this.props.user.role === 'superAdmin' ||
                  this.props.user.role === 'companyGroupAdmin' ||
                  this.props.user.role === 'companyGroupManager' ||
                  this.props.user.role === 'admin' ||
                  this.props.user.role === 'enterpriseAdmin' ? (
                  <Col
                    md={3}
                    className="select-limit"
                  >
                    {this.props.companies.docs && (
                      <InputGroup>
                        <InputGroupAddon addonType="prepend" className="filter-icon-div">
                          <img src={filterIcon} className="filter-icon" alt="..." />
                        </InputGroupAddon>
                        <CompanyAutocomplete
                          className="width72"
                          searchTerm={this.props.companyFilter.value}
                          placeholder="Filter Company"
                          companies={this.props.companies.docs}
                          onChange={this.companySearchFilter}
                        />
                      </InputGroup>
                    )}
                  </Col>
                ) : null}
                {(this.props.user.role === 'superAdmin' ||
                  this.props.user.role === 'companyGroupAdmin' ||
                  this.props.user.role === 'companyGroupManager' ||
                  this.props.user.role === 'admin' ||
                  this.props.user.role === 'enterpriseAdmin') &&
                  (emails !== null && this.state.selectedCompany !== '' ? (
                    <Col md={{ size: 3, offset: 0 }}>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend" className="filter-icon-div">
                          <img src={filterIcon} className="filter-icon" alt="..." />
                        </InputGroupAddon>
                        <UsersAutocomplete
                          className="width72"
                          searchTerm={emails.email}
                          placeholder="User Filter..."
                          users={emails.emails || []}
                          onChange={this.onUserTypeSelect}
                        />
                      </InputGroup>
                    </Col>
                  ) : null)}

                <DateRangePicker
                  autoUpdateInput
                  startDate={date[1] || startOfDay(new Date())}
                  endDate={date[0] || endOfDay(new Date())}
                  onApply={this.onApply}
                  showCustomRangeLabel
                  alwaysShowCalendars
                  ranges={this.ranges}
                  opens="left"
                  onHide={this.handeleClick}
                  onShow={this.handeleClick}
                >
                  <div className="input-group" style={{ alignItems: 'center' }}>
                    <span className="input-group-btn">
                      <Button
                        className="default date-range-toggle"
                        style={{
                          background: '#DDE6FA',
                          border: 'none',
                          color: '#FF2437',
                          width: '4rem',
                        }}
                      >
                        <img style={{ width: '50%' }} src={Calendar} alt="..." />
                      </Button>
                    </span>
                    <div className="view-data-input">
                      {format(date[1], 'MM/dd/yyyy')} - {format(date[0], 'MM/dd/yyyy')}
                    </div>
                  </div>
                </DateRangePicker>
              </Row>
            </Col>
          </Row>
        </div>
        <Container fluid style={{ margin: 0 }}>
          <div className="viewContainer">
            <Row>
              <Col md={12}>
                {/* {vmail.docs ? ( */}
                <VmailsList
                  onRecover={this.onRecoverVmail}
                  deleteMode={deleteMode}
                  vmails={renderList || []}
                  onDelete={e => {
                    this.setState({ deleteVmail: e });
                    this.props.showDeleteUser(e);
                  }}
                  sortValue={sort}
                  onSort={this.handleSortVmail}
                />
                {/* ) : (
              <Alert rowSpan={12} color="info">
                No Voice Mails Found
              </Alert>
            )} */}
              </Col>
            </Row>

            {vmail.totalPages > 1 && (
              <Row className="justify-content-md-center">
                <SetLimitEntries value={vmail.limit} onChange={this.handleSetLimit} />
                <Pagination
                  locale={ENG_LOCALE}
                  className="pagination-container"
                  onChange={this.handleChangePagination}
                  current={vmail.page}
                  total={vmail.totalDocs}
                  pageSize={vmail.limit}
                  showLessItems
                  showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                />
              </Row>
            )}

            {/* <Row>
              <Col md={12}>
                {vmail.totalPages > 1 && (
                  <Pagination
                    className="pagination-container"
                    onChange={this.handleChangePagination}
                    current={vmail.page}
                    total={vmail.totalDocs}
                    pageSize={vmail.limit}
                    showLessItems
                  />
                )}
              </Col>
            </Row> */}
          </div>
          <DeleteModal
            data={'Voice Mail'}
            isOpen={this.props.deleteShow}
            onCancel={this.props.cancelDeleteUser}
            onConfirm={this.onDelete}
          />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  deleteShow: state.UIState.users.deleteShow,
  user: state.AppState.user,
  companies: state.AppState.companies,
  companyFilter: state.UIState.epikBoxes.companyFilter,
  emails: state.UIState.numbers.filterNumbersByCompany.number,
  numbers: state.AppState.numbers,
  number: state.UIState.numbers.addNumber,
  vmail: state.AppState.vmails.vmails,
  deleteMode: state.AppState.deleteMode,
});

const mapDispatchToProps = dispatch => ({
  onRecover: (token, id) => dispatch(VmailActions.onRecover(token, id)),
  deleteVMail: (token, id) => dispatch(VmailActions.deleteVMail(token, id)),
  cancelDeleteUser: () => dispatch(cancelDeleteUser()),
  showDeleteUser: id => dispatch(showDeleteUser(id)),
  getCompanyNumbers: (token, id, uid, type) => dispatch(getCompanyNumbers(token, id, uid, type)),
  getAllVmails: (token, paginateOptions, dateFilter) =>
    dispatch(VmailActions.getAllVmails(token, paginateOptions, dateFilter)),
  getVmailByCompany: (token, id, paginateOptions, date) =>
    dispatch(VmailActions.getVmailByCompany(token, id, paginateOptions, date)),
  getVmailsByUser: (token, userID, paginateOptions, date) =>
    dispatch(VmailActions.getVmailsByUser(token, userID, paginateOptions, date)),

  getCompanies: (token, pagination, disablePaginate) =>
    dispatch(CompanyActions.getCompanies(token, pagination, disablePaginate)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Vmails));
